import { render, staticRenderFns } from "./DestinationLandingPage.vue?vue&type=template&id=b5deb7ac&"
import script from "./DestinationLandingPage.vue?vue&type=script&lang=js&"
export * from "./DestinationLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./DestinationLandingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports